module.exports = __webpack_public_path__ + "img/Business Person 3.59ae1ee7.jpg";